import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable consistent-return */
import { useEffect, useMemo, useState } from 'react';
import { prefixLogger } from '@civic/gateway-client-core';
import { ICPChainImplementation } from '@civic/icp-gateway-chain-client';
import { GatewayProvider } from '@civic/gateway-client-react';
import { VERSION } from './version';
const logInfo = prefixLogger('ICPGatewayProvider').info;
const logDebug = prefixLogger('ICPGatewayProvider').debug;
// eslint-disable-next-line import/prefer-default-export
export const ICPGatewayProvider = ({ children = null, wallet, gatekeeperNetwork, wrapper, logo, stage = 'prod', redirectUrl, payer, options, forceRequireRefresh, }) => {
    const [icpNetwork, setIcpNetwork] = useState();
    useEffect(() => {
        const abortController = new AbortController();
        if (!wallet) {
            logDebug('useEffect: no wallet, returning', { wallet });
            return;
        }
        const getPublicKeyAndNetwork = async () => {
            if (abortController.signal.aborted) {
                return;
            }
            if (!wallet.principal) {
                return;
            }
            logDebug('setting network', { network: 'civic' });
            setIcpNetwork({ name: 'civic' });
        };
        logDebug('getting public key and network...');
        getPublicKeyAndNetwork();
        return () => abortController.abort();
    }, [wallet]);
    // these values are dependant on one-another so they need to all change together if an input changes
    const gatewayProviderProps = useMemo(() => {
        return {
            walletAddress: wallet === null || wallet === void 0 ? void 0 : wallet.principal,
            chainImplementation: icpNetwork && (wallet === null || wallet === void 0 ? void 0 : wallet.principal)
                ? new ICPChainImplementation({
                    wallet: wallet,
                    network: icpNetwork,
                    owner: wallet.principal,
                    gatekeeperNetwork,
                    stage,
                    chainPollingIntervalMs: options === null || options === void 0 ? void 0 : options.chainPollingIntervalMs,
                })
                : undefined,
            stage,
            gatekeeperNetwork,
            options,
            expectTokenTimeoutSeconds: 120,
            payer,
            disableInitialGatekeeperLookup: [
                'tigoYhp9SpCDoCQmXGj2im5xa3mnjR1zuXrpCJ5ZRmi',
                'ignREusXmGrscGNUesoU9mxfds9AiYTezUKex2PsZV6',
            ].includes(gatekeeperNetwork),
        };
    }, [wallet === null || wallet === void 0 ? void 0 : wallet.principal, icpNetwork, gatekeeperNetwork, stage, options, payer]);
    useEffect(() => {
        logInfo('Client Options', Object.assign(Object.assign({}, gatewayProviderProps), { forceRequireRefresh }));
    }, [gatewayProviderProps, forceRequireRefresh]);
    return (_jsx(GatewayProvider
    // memoised values that need to be synchronised
    , Object.assign({ 
        // memoised values that need to be synchronised
        walletAddress: gatewayProviderProps.walletAddress, chainImplementation: gatewayProviderProps.chainImplementation, stage: gatewayProviderProps.stage, gatekeeperNetwork: gatewayProviderProps.gatekeeperNetwork, options: gatewayProviderProps.options, payer: gatewayProviderProps.payer, disableInitialGatekeeperLookup: gatewayProviderProps.disableInitialGatekeeperLookup, 
        // eslint-disable-next-line react/jsx-boolean-value
        gatekeeperSendsTransaction: true, 
        // non-memoised values that don't need to be synchronised
        expectTokenTimeoutSeconds: 120, wrapper: wrapper, logo: logo, redirectUrl: redirectUrl, 
        // Sent to the Gatekeeper in the x-civic-client version header.
        // If this is not passed in, the version of the generic gateway-client-react package will be used.
        reactComponentVersion: VERSION, forceRequireRefresh: forceRequireRefresh }, { children: children })));
};
export { useICPGateway } from './gateway/useICPGateway';
